<template>
    <div class="hs-container">
        <div class="order-search-box">
            <div class="search-left">
                <el-select v-model="query.complete" filterable collapse-tags clearable placeholder="订单属性" class="handle-select mr10">
                    <el-option v-for="(row, index) in orderTypeList" :key="index" :label="row.title" :value="row.id"></el-option>
                </el-select>
                <el-select v-model="query.company_id" filterable multiple collapse-tags clearable placeholder="选择公司" class=" mr10">
                    <el-option v-for="(row, index) in companyList" :key="index" :label="row.title" :value="row.id"></el-option>
                </el-select>

                <el-select v-model="query.cooperation_mode" filterable multiple collapse-tags clearable placeholder="合作模式" class="handle-select mr10">
                    <el-option v-for="(row, index) in cooperationModeList" :key="index" :label="row.title" :value="row.id"></el-option>
                </el-select>

                <el-select v-model="query.date_type" placeholder="时间类型" class="handle-select mr10">
                    <el-option key="event_date" label="举办日期" value="event_date"></el-option>
                    <el-option key="sign_date" label="签单日期" value="sign_date"></el-option>
                    <el-option key="create_time" label="创建日期" value="create_time"></el-option>
                </el-select>
                <el-date-picker class="daterange mr10" v-model="query.range" type="daterange" align="right" unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <el-button type="primary" icon="el-icon-download" @click="exportExcel">导出</el-button>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">刷新 </el-button>
            </div>
            <div class="search-right">
                <el-popover class="popover" placement="bottom" width="520" trigger="click">
                    <el-button slot="reference" class="screen-out">
                        <i class="el-icon-s-help" style="margin-right: 5px"></i>更多筛选项
                    </el-button>
                    <div class="popover-body">
                        <div class="popover-datail">
                            <span>部门查找：</span>
                            <el-cascader ref="cascader" v-if="departmentTree.length > 0" class="popover-left popover-wid" style="width: 80%" placeholder="按部门查找" :props="{ checkStrictly: true }" :options="departmentTree" filterable clearable :show-all-levels="false" @change="handleCascader"></el-cascader>
                        </div>
                        <div class="popover-datail">
                            <span>选择销售：</span>
                            <el-select v-model="query.user_id" filterable multiple collapse-tags clearable placeholder="选择销售" class="popover-left popover-wid">
                                <el-option v-for="(row, index) in staffList" :key="index" :label="row.realname" :value="row.id"></el-option>
                            </el-select>
                        </div>
                        <div class="popover-datail">
                            <span>选择酒店：</span>
                            <el-select v-model="query.hotel_id" filterable multiple collapse-tags clearable placeholder="选择酒店" class="popover-left popover-wid">
                                <el-option v-for="(row, index) in hotelList" :key="index" :label="row.title" :value="row.id"></el-option>
                            </el-select>
                        </div>
                        <template v-if="auth.is_search_source > 0">
                            <div class="popover-datail">
                                <span>选择来源：</span>
                                <el-select v-model="query.source_id" filterable collapse-tags clearable placeholder="选择来源" @change="getSourceId" class="popover-left popover-wid">
                                    <el-option v-for="(row, index) in sourceList" :key="index" :label="row.title" :value="row.id"></el-option>
                                </el-select>
                            </div>
                            <div class="popover-datail" v-if="accountCity.length && !showCity">
                                <span>选择区域：</span>
                                <el-select v-model="query.account_city_id" filterable collapse-tags clearable placeholder="选择区域" @change="changeAccountCity" class="popover-left popover-wid">
                                    <el-option v-for="(row, index) in accountCity" :key="index" :label="dictionary.getRegionItem(row, '无')" :value="row"></el-option>
                                </el-select>
                            </div>
                            <div class="popover-datail" v-if="accountList.length">
                                <span>选择账户：</span>
                                <el-select v-model="query.account_id" filterable collapse-tags clearable placeholder="选择账户" @change="changeAccount" class="popover-left popover-wid">
                                    <el-option v-for="(row, index) in accountList" :key="index" :label="row.title" :value="row.id"></el-option>
                                </el-select>
                            </div>
                        </template>
                    </div>
                    <div class="popover-bottom">
                        <el-button @click="resetFn">重置</el-button>
                        <el-button type="primary" @click="handleSearch">搜索</el-button>
                    </div>
                </el-popover>
            </div>
        </div>

        <!-- <div class="handle-box">
        <el-select v-model="query.complete" filterable collapse-tags clearable placeholder="订单属性" class="handle-select mr10 w7rem" style="width:11.5rem;margin-bottom: 5px;">
            <el-option v-for="(row,index) in orderTypeList" :key="index" :label="row.title" :value="row.id"></el-option>
        </el-select>

        <el-cascader v-if="departmentTree.length > 0" class="mr10 w10rem" placeholder="按部门查找" :props="{ checkStrictly: true }" :options="departmentTree" filterable clearable :show-all-levels="false" @change="handleCascader"></el-cascader>
        <el-select v-model="query.user_id" filterable multiple collapse-tags clearable placeholder="选择销售" class="handle-select mr10 w7rem" style="width:9rem;">
            <el-option v-for="(row,index) in staffList" :key="index" :label="row.realname" :value="row.id"></el-option>
        </el-select>

        <el-select v-model="query.hotel_id" filterable multiple collapse-tags clearable placeholder="选择酒店" class="handle-select mr10 w7rem" style="width:11.5rem;">
            <el-option v-for="(row,index) in hotelList" :key="index" :label="row.title" :value="row.id"></el-option>
        </el-select>
        <el-select v-model="query.source_id" filterable collapse-tags clearable placeholder="选择来源" @change="getSourceId" class="handle-select mr10 w7rem" style="width:11.5rem;">
            <el-option v-for="(row,index) in sourceList" :key="index" :label="row.title" :value="row.id"></el-option>
        </el-select>
        <el-select v-model="query.account_city_id" filterable collapse-tags clearable placeholder="选择区域" @change="changeAccountCity" v-if="accountCity.length && !showCity" class="handle-select mr10 w7rem" style="width:11.5rem;">
            <el-option v-for="(row,index) in accountCity" :key="index" :label="dictionary.getRegionItem(row, '无')" :value="row"></el-option>
        </el-select>
        <el-select v-model="query.account_id" filterable collapse-tags clearable placeholder="选择账户" @change="changeAccount" v-if="accountList.length" class="handle-select mr10 w7rem" style="width:11.5rem;">
            <el-option v-for="(row,index) in accountList" :key="index" :label="row.title" :value="row.id"></el-option>
        </el-select>
        <el-select v-model="query.company_id" filterable multiple collapse-tags clearable placeholder="选择公司" class="handle-select mr10 w7rem" style="width:11.5rem;">
            <el-option v-for="(row,index) in companyList" :key="index" :label="row.title" :value="row.id"></el-option>
        </el-select>

        <el-select v-model="query.cooperation_mode" filterable multiple collapse-tags clearable placeholder="合作模式" class="handle-select mr10 w7rem" style="width:10.5rem;">
            <el-option v-for="(row,index) in cooperationModeList" :key="index" :label="row.title" :value="row.id"></el-option>
        </el-select>

        <el-select v-model="query.date_type" placeholder="时间类型" class="handle-select mr10" style="width:10rem;">
            <el-option key="event_date" label="举办日期" value="event_date"></el-option>
            <el-option key="sign_date" label="签单日期" value="sign_date"></el-option>
            <el-option key="create_time" label="创建日期" value="create_time"></el-option>
        </el-select>
        <el-date-picker class="daterange mr10" v-model="query.range" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" icon="el-icon-download" @click="exportExcel">导出</el-button>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">刷新  </el-button>
    </div> -->

        <el-table id="out-table" :data="tableData" :height="height" border class="table" ref="multipleTable" header-cell-class-name="table-header" :default-sort="{ prop: 'sign_date' }" :show-summary="true" :summary-method="getSummaries" v-loading="loading">
            <el-table-column type="index" width="60" align="center" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <template>
                        <el-button v-has="[87]" type="primary" size="mini" @click="showEditDrawer(scope)">编辑</el-button>
                    </template>
                    <template v-if="user.id == scope.row.profit.user_id && scope.row.profit.item_check_status == 3">
                        <el-button type="primary" size="mini" @click="$refs.editProfit.showDrawer(scope.row.profit)">编辑</el-button>
                    </template>
                    <template v-else></template>
                </template>
            </el-table-column>
            <el-table-column prop="item_check_status" label="审核状态"></el-table-column>
            <el-table-column prop="news_type" label="订单类型" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="complete" label="订单性质" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="cooperation_mode_text" label="合作模式" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="sign_date" label="签单日期" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="event_date" label="举办日期" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="source" label="渠道" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="hotel" label="酒店" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="banquet_hall_name" label="厅" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="newer" label="新人姓名" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="cmobile" label="联系方式" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="totals" label="合同总额" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="table_price" label="餐标" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="table_amount" label="桌数" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="wine_fee" label="酒水" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="service_fee" label="服务费" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="wedding_totals" label="婚庆金额" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="profit.pay_hotel_fee" label="应付酒店" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="profit.income_fee" label="收入总额" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="profit.source_fee" label="平台渠道" width="100" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span>{{ scope.row.profit.source_fee }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="profit.source_fee_remark" label="备注" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="person_source_fee" label="个人渠道" width="100" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span>{{ scope.row.profit.person_source_fee }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="profit.person_source_fee" label="备注" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="profit.wine_cost" label="酒水成本" width="100" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span>{{ scope.row.profit.wine_cost }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="profit.wine_cost_remark" label="备注" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="profit.free_cost" label="赠送成本" width="100" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span>{{ scope.row.profit.free_cost }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="profit.free_cost_remark" label="备注" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="profit.wedding_cost" label="婚庆签单额" width="100" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span>{{ scope.row.profit.wedding_cost }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="profit.wedding_cost_remark" label="备注" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="profit.banquet_profit" label="婚宴净利" width="100" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span>{{ scope.row.profit.banquet_profit }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="profit.banquet_profit_remark" label="备注" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="salesman" label="婚宴签单人" align="center" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="manager" label="审核区域" align="center" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="department" label="所属部门" align="center" width="100" :show-overflow-tooltip="true"></el-table-column>
        </el-table>
        <editBox ref="editBox" @getData="getData"></editBox>
        <editProfit ref="editProfit"></editProfit>
    </div>
</template>

<script>
import './common.css';
import { has } from '@/utils/promissions';
import { checkDataAuth } from '@/utils/common.js';

import fileSaver from 'file-saver';
import xlsx from 'xlsx';
import editBox from './edit.vue';
import editProfit from '../order/profit/order.edit.vue';
import dictionary from '@/utils/dictionary.js';
export default {
    components: {
        editBox,
        editProfit
    },
    name: 'basetable',
    data() {
        let accountPickerList = dictionary.getPicker('account');
        return {
            loading: false,
            sumFields: ['totals', 'wedding_totals', 'profit.banquet_profit'],
            height: 660,
            departmentTree: [],
            tableData: [],
            orderTypeList: [
                {
                    id: '',
                    title: '所有订单'
                },
                {
                    id: 0,
                    title: '普通订单'
                },
                {
                    id: 98,
                    title: '定金订单'
                },
                {
                    id: 99,
                    title: '意向金订单'
                },
                {
                    id: 101,
                    title: '退单'
                }
            ],
            auth: {},
            query: {
                complete: '',
                department_id: '',
                user_id: '',
                source_id: '',
                account_city_id: '',
                account_id: '',
                hotel_id: '',
                company_id: '',
                cooperation_mode: '',
                date_type: '',
                keyword: '',
                range: []
            },
            companyList: [],
            sourceList: [],
            hotelList: [],
            staffList: [],
            cooperationModeList: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            user: '',
            accountPickerList: accountPickerList, //从本地获取的账号列表
            accountSourceList: [], //和选择的来源id匹配后的账号列表
            accountCity: [], //匹配来源后的城市列表
            accountList: [], //匹配来源和城市后的账号列表
            showCity: false
        };
    },
    beforeMount() {
        this.dictionary = dictionary;
    },
    created() {
        this.height = window.innerHeight * 0.75;
        this.user = JSON.parse(localStorage.getItem('user'));

        this.getData();
        // 获取部门树
        this.getDepartmentTree();
        // 获取picker
        this.getPicker();
        // 验证搜索权限
        let _this = this;
        checkDataAuth().then((res) => {
            _this.auth = res;
        });
    },
    methods: {
        // 选择来源
        getSourceId(id) {
            this.query.source_id = id;
            this.query.account_city_id = '';
            this.query.account_id = '';
            this.accountCity = [];
            this.accountList = [];
            this.showCity = false;
            let accountSourceList = [];
            let cityArr = [];
            this.accountPickerList.forEach((item, index) => {
                if (item.source_id == id) {
                    accountSourceList.push(item);
                }
            });
            this.accountSourceList = accountSourceList;
            this.accountSourceList.forEach((item, index) => {
                cityArr.push(item.city_id);
            });
            // 城市去重
            cityArr.sort();
            let newCityArr = [cityArr[0]];
            for (var i = 0; i < cityArr.length; i++) {
                if (cityArr[i] !== newCityArr[newCityArr.length - 1]) {
                    newCityArr.push(cityArr[i]);
                }
            }
            this.accountCity = newCityArr;
            // 没有区域直接选账号
            if (this.accountCity.length == 1 && this.accountCity[0] == 0) {
                this.accountList = this.accountSourceList;
                if (this.accountList.length) {
                    this.showCity = true;
                }
            }
            // 区域只有无并且无匹配账号
            if (this.accountCity.length == 1 && !this.accountCity[0] && !this.accountList.length) {
                this.showCity = true;
            }
        },
        // 来源城市匹配账号
        changeAccountCity(id) {
            this.query.account_city_id = id;
            this.query.account_id = '';
            let accountList = [];
            this.accountSourceList.forEach((item, index) => {
                if (item.city_id == id && item.source_id == this.query.source_id) {
                    accountList.push(item);
                }
            });
            this.accountList = accountList;
        },
        // 重置
        resetFn() {
            this.query.department_id = '';
            this.query.user_id = '';
            this.query.source_id = '';
            this.query.account_city_id = '';
            this.query.account_id = '';
            this.query.hotel_id = '';
            this.$refs.cascader.$refs.panel.clearCheckedNodes(); //清空部门查找 级联选择器选择的节点
        },
        // 选择账户
        changeAccount(id) {
            this.query.account_id = id;
        },
        getData() {
            let that = this;
            let url = '/api/statistics.fiance/profit';
            let query = that.query;
            that.loading = true;
            this.$post(url, query).then(function (response) {
                let result = response.data;
                that.tableData = result.list;
                that.loading = false;
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.getData();
        },
        // 获取部门树
        getDepartmentTree() {
            let url = '/api/ucenter.department/getDepartmentTree';
            let that = this;
            this.$post(url, {}).then(function (response) {
                that.departmentTree = response.data.tree;
            });
        },
        // 获取Picker
        getPicker() {
            let url = '/api/statistics.picker/items';
            let that = this;
            this.$post(url, {}).then(function (response) {
                that.companyList = response.data.companyList;
                that.cooperationModeList = response.data.cooperationModeList;
                that.sourceList = response.data.sourceList;
                that.hotelList = response.data.hotelList;
            });
        },
        handleCascader(e) {
            let last = e.length - 1;
            this.query.department_id = e[last];
            let that = this;
            let url = '/api/ucenter.user/getDepartmentUserList';
            let query = {
                id: e[last]
            };
            // 添加或编辑客资信息
            that.$post(url, query).then(function (response) {
                if (response.code != '200') {
                    that.$message.error(response.msg);
                } else {
                    that.staffList = response.data.list;
                }
            });
        },
        exportExcel() {
            /* 从表生成工作簿对象 */
            var wb = xlsx.utils.table_to_book(document.querySelector('#out-table'));
            /* 获取二进制字符串作为输出 */
            var wbout = xlsx.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            });
            try {
                fileSaver.saveAs(
                    //Blob 对象表示一个不可变、原始数据的类文件对象。
                    //Blob 表示的不一定是JavaScript原生格式的数据。
                    //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
                    //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
                    new Blob([wbout], {
                        type: 'application/octet-stream'
                    }),
                    //设置导出文件名称
                    'sheetjs.xlsx'
                );
            } catch (e) { }
            return wbout;
        },

        // 编辑/创建抽屉
        showEditDrawer(options) {
            let data = options.row;
            this.$refs.editBox.handleShow(data);
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总价';
                    return;
                }

                if (this.sumFields.indexOf(column.property) < 0) {
                    sums[index] = '';
                    return;
                }
                let values = [];
                if (this.sumFields.indexOf(column.property) == 2) {
                    values = data.map((item) => Number(item.profit.banquet_profit));
                } else {
                    values = data.map((item) => Number(item[column.property]));
                }
                if (!values.every((value) => isNaN(value))) {
                    let sum = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);

                    sums[index] = sum.toFixed(2);
                } else {
                    sums[index] = '';
                }
            });
            return sums;
        }
    }
};
</script>

<style lang="less" scoped>
@import url('@/assets/css/order.less');

.top-search {
    width: 100%;
    padding: 20px 0;
    box-sizing: border-box;
}
</style>
